import { Button } from '@/components/ui/button'
import { Select } from 'antd'
import { TradingAccountDto } from 'api/Clients/Types/TradingAccount'
import { WalletDto } from 'api/Wallet/Types/Wallet'
import { FilterDescriptor } from 'store/grid'
import { isEmpty, isNotEmpty } from 'utils/is-empty'

export type SelectTaModalOpenEvent = { filterId?: string; value: boolean }

export const SelectTradingAccountFilter = ({
  filter,
  onFilterChange,
  onTaModalOpen,
}: {
  filter: FilterDescriptor
  onFilterChange: (event: { nextFilter: FilterDescriptor }) => void
  onTaModalOpen?: (event: SelectTaModalOpenEvent) => void
}): JSX.Element => {
  const taSelected = filter?.value ?? []
  const selectValues = filter?.value?.map((wallet: WalletDto) => wallet.id) ?? []

  if (isEmpty(selectValues) && onTaModalOpen) {
    return (
      <Button
        variant='outline'
        size='sm'
        type='button'
        onClick={() => onTaModalOpen({ filterId: filter.id, value: true })}
      >
        Choose Trading Accounts
      </Button>
    )
  }

  return (
    <Select
      placeholder='Trading Accounts'
      mode='multiple'
      value={selectValues}
      open={false}
      onFocus={() => {
        if (onTaModalOpen) {
          onTaModalOpen({ filterId: filter.id, value: true })
        }
      }}
      onChange={(values: string[]) => {
        const taState = isNotEmpty(values)
          ? taSelected.filter((x: WalletDto) => values.includes(x.id))
          : []

        onFilterChange.call(undefined, {
          nextFilter: { ...filter, value: taState },
        })
      }}
      style={{ width: '250px' }}
    >
      {taSelected.map((x: TradingAccountDto) => (
        <Select.Option value={x.id} key={x.id}>
          {x.name}
        </Select.Option>
      ))}
    </Select>
  )
}
